<template>
  <v-card>
    <v-card-text>
      <v-layout class="row wrap">
        <v-flex d-flex xs12 class="beez-padding">
          <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
            <v-flex pa-2 ma-2>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg4>
                      <div class="text-xs-left">
                        <br />
                        <div>Unique Identifier</div>
                        <div class="subheading">
                          {{ item.hexId }}
                        </div>
                        <br />
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 lg4 v-if="type === 'Bot'">
                      <div class="text-xs-left">
                        <br />
                        <div>Hive Description</div>
                        <div class="subheading">
                          {{ item.hive ? item.hive.description : '' }}
                        </div>
                        <br />
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 lg4 v-if="type === 'Workflow'">
                      <div class="text-xs-left">
                        <br />
                        <div>Workflow BPMN Id</div>
                        <div class="subheading">
                          {{ item.bpmnId }}
                        </div>
                        <br />
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 lg4>
                      <div class="text-xs-left">
                        <br />
                        <div>Created By</div>
                        <div class="subheading">
                          {{ item.createdByName }}
                        </div>
                        <br />
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 lg4>
                      <div class="text-xs-left">
                        <br />
                        <div>Created At</div>
                        <div class="subheading">
                          {{ item.createdAt }}
                        </div>
                        <br />
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 lg4>
                      <div class="text-xs-left">
                        <br />
                        <div>Last Successful Execution</div>
                        <div class="subheading">
                          {{ item.lastSuccessfulAtLocal }}
                        </div>
                        <br />
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 lg4>
                      <div class="text-xs-left">
                        <br />
                        <div>Last Failed Execution</div>
                        <div class="subheading">
                          {{ item.lastFailedAtLocal }}
                        </div>
                        <br />
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 style="padding-bottom: 20px">
                  <v-chip class="pull-left" v-if="item.active === true">
                    <v-avatar>
                      <v-icon class="green--text">check_circle_outline</v-icon>
                    </v-avatar>
                    Active
                  </v-chip>
                  <v-chip class="pull-left" v-if="item.active === false">
                    <v-avatar>
                      <v-icon class="grey--text">highlight_off</v-icon>
                    </v-avatar>
                    InActive
                  </v-chip>
                </v-flex>
                <v-flex xs12 md6 lg4>
                  <v-layout row wrap class="ma-2">
                    <v-flex xs2>
                      <v-avatar tile>
                        <v-icon class="secondary--text" large>functions</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs10>
                      <div class="text-xs-left">
                        <div class="subheading ">
                          {{ item.totalExecution }}
                        </div>
                        <div>Total Executions</div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6 lg4>
                  <v-layout row wrap class="ma-2">
                    <v-flex xs2>
                      <v-avatar tile>
                        <v-icon class="secondary--text" large>thumb_up</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs10>
                      <div class="text-xs-left">
                        <div class="subheading ">
                          {{ item.successRate }}
                        </div>
                        <div>Success Rate</div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6 lg4>
                  <v-layout row wrap class="ma-2">
                    <v-flex xs2>
                      <v-avatar tile>
                        <v-icon class="secondary--text" large>timer</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs10>
                      <div class="text-xs-left">
                        <div class="subheading ">
                          {{ item.avgExecutionTime }}
                        </div>
                        <div>Average Resolution Time</div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex d-flex xs12 md6 lg4 v-if="type === 'Bot'">
                  <v-layout row wrap class="ma-2">
                    <v-flex xs2>
                      <v-avatar tile>
                        <v-icon class="secondary--text" large
                          >attach_money
                        </v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs10>
                      <div class="text-xs-left">
                        <div class="subheading">
                          {{ item.fteReduction }}
                        </div>
                        <div>Effort savings per run</div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex d-flex xs12 md6 lg4 v-if="type === 'Bot'">
                  <v-layout row wrap class="ma-2">
                    <v-flex xs2>
                      <v-avatar tile>
                        <v-icon class="secondary--text" large
                          >attach_money
                        </v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs10>
                      <div class="text-xs-left">
                        <div class="subheading ">
                          {{ item.effortSavings }}
                        </div>
                        <div>Total Effort savings</div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-spacer />
                <v-layout
                  align-center
                  fill-height
                  v-if="type === 'Workflow'"
                  style=" padding: 10px;"
                >
                </v-layout>
              </v-layout>
              <br />
              <v-divider></v-divider>
              <br />
              <v-card-actions>
                <template
                  v-if="type === 'Bot' && proposalContainsTemplate(item)"
                >
                  <a
                    class="ml-2"
                    ref="templateUrl"
                    :href="'/api/core/dms/read/' + getTemplateLink(item)"
                    v-show="false"
                  />
                  <v-btn
                    color="secondary"
                    class="text-capitalize"
                    @click="$refs.templateUrl.click()"
                  >
                    Download Proposal Template
                    <v-icon right>cloud_download</v-icon>
                  </v-btn>
                </template>
                <v-btn
                  flat
                  v-if="can('DASHBOARD_GOTOSERVICE')"
                  :outline="$vuetify.dark"
                  class="text-capitalize mx-2"
                  :to="{
                    name: type === 'Bot' ? 'bot-detail' : 'workflow-detail',
                    params: { hexId: item.hexId }
                  }"
                >
                  <v-icon>
                    reply
                  </v-icon>
                  <span class="pl-2">Go To Service</span>
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment/moment'

export default {
  name: 'service-card',
  components: {},
  data() {
    return {}
  },
  props: {
    item: {},
    type: String
  },
  computed: {
    ...mapGetters({
      can: 'can'
    })
  },
  methods: {
    format(input) {
      return _.capitalize(_.startCase(input))
    },
    getLocalTime(input) {
      return moment(input)
        .utc()
        .local()
        .format('DD MMM YYYY, hh:mm:ss a')
    },
    proposalContainsTemplate(bot) {
      if (bot.proposals) {
        for (var i = 0; i < bot.proposals.length; i++) {
          var field = bot.proposals[i]
          if (field.name === 'Template_Doc_Id') {
            return true
          }
        }
        return false
      }
    },

    getTemplateLink(bot) {
      for (var i = 0; i < bot.proposals.length; i++) {
        var field = bot.proposals[i]
        if (field.name === 'Template_Doc_Id') {
          return field.defaultValue
        }
      }
      throw new Error('template link cannot be retrieved for bot: ', bot)
    }
  }
}
</script>
<style scoped>
.secondary--text {
  color: #424242;
}

.time-chart white {
  background-color: white;
}

.workflow-widget {
  height: 350px;
  margin-bottom: 6px;
}
</style>
